import { Form } from '@/hooks/use-form-field';
import { convertEmptyStringsToNull } from '@/schemas/converters';
import { ActionFormProps, FormValues } from '@/constants/formTypes';
import { DynamicRenderer } from './DynamicRenderer';
import { useAction } from '@/hooks/use-action';
import useDynamicForm from '@/hooks/use-dynamic-form';
import { decodeSubmission } from '@/schemas/validation/ValidationSchemaGenerator';

export function DynamicActionForm({ formData, route }: ActionFormProps) {
  const { isLoading, executeAction } = useAction();
  const form = useDynamicForm(formData.components);

  function handleFormSubmit(data: FormValues) {
    if (isLoading) {
      return;
    }
    const convertedData = convertEmptyStringsToNull(data);
    const decodedData = decodeSubmission(convertedData);

    // Merge server-supplied arguments (e.g., entity_index from the map loop) with the decoded
    // form fields. Arguments are already resolved/interpolated server-side; they bypass the
    // field-key encoding entirely.
    const payload = {
      ...decodedData,
      ...(formData.arguments ?? {}),
    };

    void executeAction(formData.action_name, payload, route);
  }

  return (
    <Form {...form}>
      <form
        onSubmit={(ev) => void form.handleSubmit(handleFormSubmit)(ev)}
        id={formData.id ?? ''}
      >
        <DynamicRenderer
          form={form}
          components={formData.components}
          route={route}
          submit={handleFormSubmit}
        />
      </form>
    </Form>
  );
}
